export const displayTime = (secondsInput: number) => {
  const minutes = Math.floor(secondsInput / 60)
  const seconds = secondsInput - minutes * 60
  return `${minutes}:${String(seconds).padStart(2, '0')} min.`
}
